import React, { useEffect } from "react";
import CategoriesTemplate from "../../Templetes/Categories/Categories.template";

const CategoriesPage = () => {
  useEffect(() => {
    document.title = "Code Challenge - Competition Categories";
  }, []);
  return <CategoriesTemplate />;
};

export default CategoriesPage;
